import { Controller } from "@hotwired/stimulus"

// Ícone play
const PLAY_INNER =
  '<svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" /></svg>'
// Ícone pause
const PAUSE_INNER =
  '<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="14" y="3" width="5" height="18" rx="1" /><rect x="5" y="3" width="5" height="18" rx="1" /></svg>'
const LOADING_INNER =
  '<span class="loading loading-spinner loading-sm"></span>'

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    this.boundRadioPlay = this.onRadioPlay.bind(this)
    this.boundRadioPlayback = this.onRadioPlayback.bind(this)
    this.boundRadioLoading = this.onRadioLoading.bind(this)
    window.addEventListener("radio:play", this.boundRadioPlay)
    window.addEventListener("radio:playback", this.boundRadioPlayback)
    window.addEventListener("radio:loading", this.boundRadioLoading)
  }

  disconnect() {
    window.removeEventListener("radio:play", this.boundRadioPlay)
    window.removeEventListener("radio:playback", this.boundRadioPlayback)
    window.removeEventListener("radio:loading", this.boundRadioLoading)
  }

  sameUrl(a, b) {
    if (!a || !b) return false
    try {
      return (
        new URL(a, window.location.href).href ===
        new URL(b, window.location.href).href
      )
    } catch {
      return a === b
    }
  }

  stationUrl() {
    return this.element.dataset.stationUrl || ""
  }

  setPlayingUI(playing) {
    if (!this.hasIconTarget) return
    const name = this.element.dataset.stationName || "rádio"
    this.iconTarget.innerHTML = playing ? PAUSE_INNER : PLAY_INNER
    this.element.disabled = false
    this.element.setAttribute(
      "aria-label",
      playing ? `Pausar ${name}` : `Reproduzir ${name}`
    )
  }

  setLoadingUI(loading) {
    if (!this.hasIconTarget) return
    if (loading) {
      this.iconTarget.innerHTML = LOADING_INNER
      this.element.disabled = true
      return
    }
    this.element.disabled = false
  }

  onRadioPlay(event) {
    const url = event.detail?.url
    this.setPlayingUI(this.sameUrl(this.stationUrl(), url))
  }

  onRadioPlayback(event) {
    const { streamUrl, playing } = event.detail || {}
    const mine = this.stationUrl()
    if (!mine) return

    const active = streamUrl && this.sameUrl(mine, streamUrl)

    if (playing) {
      this.setPlayingUI(active)
    } else if (active) {
      this.setPlayingUI(false)
    }
  }

  onRadioLoading(event) {
    const { url, loading } = event.detail || {}
    if (!this.sameUrl(this.stationUrl(), url)) return

    this.setLoadingUI(loading)
    if (!loading) {
      this.setPlayingUI(false)
    }
  }

  playStation(event) {
    event.preventDefault()
    const el = event.currentTarget
    const url = el.dataset.stationUrl
    const name = el.dataset.stationName
    const logo = el.dataset.stationLogo

    if (!url) {
      console.error("station-button: stream_url ausente")
      return
    }

    window.dispatchEvent(
      new CustomEvent("radio:play", { detail: { url, name, logo } })
    )
  }
}
